export type AppNavItem = {
  name: string;
  // Material Symbols icon name
  icon: string;
  href?: string;
  children?: AppNavItem[];
};

export const APP_NAV_ITEMS: Record<string, AppNavItem[]> = {
  admin: [
    { name: "Dashboard", href: "/dashboard", icon: "dashboard" },
    {
      name: "Question Bank",
      icon: "library_books",
      children: [
        { name: "Listening", href: "/admin-listening", icon: "headphones" },
        { name: "Reading", href: "/admin-reading", icon: "auto_stories" },
        { name: "Writing", href: "/admin-writing", icon: "edit_note" },
        { name: "Speaking", href: "/admin-speaking", icon: "mic" },
      ],
    },
    { name: "Students", href: "/all-students", icon: "group" },
    { name: "Teachers", href: "/teachers", icon: "co_present" },
    { name: "Settings", href: "/admin/settings", icon: "settings" },
  ],
  student: [
    { name: "Dashboard", href: "/dashboard", icon: "dashboard" },
    { name: "Mock Test", href: "/mock-test", icon: "quiz" },
    { name: "Package Plan", href: "/package-plan", icon: "workspace_premium" },
    { name: "Contact Us", href: "/student-contact-us", icon: "mail" },
    { name: "FAQ", href: "/student-faq", icon: "help" },
    { name: "Settings", href: "/student-settings", icon: "settings" },
  ],
  teacher: [
    { name: "Dashboard", href: "/dashboard", icon: "dashboard" },
    { name: "Mock Test", href: "/mock-test", icon: "quiz" },
    { name: "Test Result", href: "/test-result", icon: "analytics" },
    { name: "Package Plan", href: "/package-plan", icon: "workspace_premium" },
    { name: "Students", href: "/students", icon: "group" },
    { name: "Settings", href: "/teacher/settings", icon: "settings" },
  ],
};

export const isNavActive = (pathname: string, href?: string) =>
  !!href && (pathname === href || pathname.startsWith(`${href}/`));

// Title for the top bar, taken from the matching nav item
export const findNavTitle = (items: AppNavItem[], pathname: string) => {
  for (const item of items) {
    if (isNavActive(pathname, item.href)) return item.name;
    const child = item.children?.find((c) => isNavActive(pathname, c.href));
    if (child) return `${item.name} · ${child.name}`;
  }
  return "";
};
